import { render, staticRenderFns } from "./ArtisanAppointmentButton.vue?vue&type=template&id=0b594984"
import script from "./ArtisanAppointmentButton.vue?vue&type=script&lang=ts"
export * from "./ArtisanAppointmentButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports